<script setup>
import CreateAccount from "@/components/parent/CreateAccount.vue";
</script>

<template>
  <CreateAccount />
</template>
